<main class="row p-0 m-0">
        <section class="header__content__dadosUsuario col-md-12 col-md-7 col-xl-12 p-0 m-0">
                <span class="header__content__dadosUsuario__title">Bem-vindo ao Você no Controle</span>
                <span class="header__content__dadosUsuario__subtitle">
                        Serviços que disponibilizamos para você ficar no controle da sua saúde e previdência.
                </span>
                <span class="header__content__dadosUsuario__name">
                        {{actualUser.name | titlecase}}
                </span>
                <span class="header__content__dadosUsuario__data" *ngIf="socialSecurityProfile">
                        <fa-icon [icon]="faCoins" class="icone__menu"></fa-icon>
                        Previdência - {{socialSecurityProfile}}
                </span>
                <span class="header__content__dadosUsuario__data"
                        *ngIf="healthProfile != null || healthProfile != undefined">
                        <fa-icon [icon]="faHeartPulse" class="icone__menu"></fa-icon>
                        Saúde - {{healthProfile}}
                </span>
        </section>
        <section class="main__content_cards col-md-12 col-md-5 col-xl-12 p-0 m-0 mais-acessado">
                <mais-acessados></mais-acessados>
        </section>
</main>